import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const PROJECT_BY_ID_REQUEST = 'sherrinford/project/detail/PROJECT_BY_ID_REQUEST'
export const PROJECT_BY_ID_SUCCESS = 'sherrinford/project/detail/PROJECT_BY_ID_SUCCESS'
export const PROJECT_BY_ID_ERROR = 'sherrinford/project/detail/PROJECT_BY_ID_ERROR'

export const QUOTATION_BY_ORDER_ID_REQUEST =
  'sherrinford/project/detail/QUOTATION_BY_ORDER_ID_REQUEST'
export const QUOTATION_BY_ORDER_ID_SUCCESS =
  'sherrinford/project/detail/QUOTATION_BY_ORDER_ID_SUCCESS'
export const QUOTATION_BY_ORDER_ID_ERROR =
  'sherrinford/project/detail/QUOTATION_BY_ORDER_ID_ERROR'

export const PO_BY_ORDER_ID_REQUEST = 'sherrinford/project/detail/PO_BY_ORDER_ID_REQUEST'
export const PO_BY_ORDER_ID_SUCCESS = 'sherrinford/project/detail/PO_BY_ORDER_ID_SUCCESS'
export const PO_BY_ORDER_ID_ERROR = 'sherrinford/project/detail/PO_BY_ORDER_ID_ERROR'

export const PUT_STATUS_PO_REQUEST = 'sherrinford/project/detail/PUT_STATUS_PO_REQUEST'
export const PUT_STATUS_PO_SUCCESS = 'sherrinford/project/detail/PUT_STATUS_PO_SUCCESS'
export const PUT_STATUS_PO_ERROR = 'sherrinford/project/detail/PUT_STATUS_PO_ERROR'

export const PUT_STATUS_ORDER_REQUEST =
  'sherrinford/project/detail/PUT_STATUS_ORDER_REQUEST'
export const PUT_STATUS_ORDER_SUCCESS =
  'sherrinford/project/detail/PUT_STATUS_ORDER_SUCCESS'
export const PUT_STATUS_ORDER_ERROR = 'sherrinford/project/detail/PUT_STATUS_ORDER_ERROR'

export const POST_EMAIL_NOTIFICATION_REQUEST =
  'sherrinford/project/detail/POST_EMAIL_NOTIFICATION_REQUEST'
export const POST_EMAIL_NOTIFICATION_SUCCESS =
  'sherrinford/project/detail/POST_EMAIL_NOTIFICATION_SUCCESS'
export const POST_EMAIL_NOTIFICATION_ERROR =
  'sherrinford/project/detail/POST_EMAIL_NOTIFICATION_ERROR'

export const POST_ORDER_TOOL_REQUEST =
  'sherrinford/project/detail/POST_ORDER_TOOL_REQUEST'
export const POST_ORDER_TOOL_SUCCESS =
  'sherrinford/project/detail/POST_ORDER_TOOL_SUCCESS'
export const POST_ORDER_TOOL_ERROR = 'sherrinford/project/detail/POST_ORDER_TOOL_ERROR'

export const GET_PURCHASE_ORDER_CREATOR_REQUEST =
  'sherrinford/project/detail/GET_PURCHASE_ORDER_CREATOR_REQUEST'
export const GET_PURCHASE_ORDER_CREATOR_SUCCESS =
  'sherrinford/project/detail/GET_PURCHASE_ORDER_CREATOR_SUCCESS'
export const GET_PURCHASE_ORDER_CREATOR_ERROR =
  'sherrinford/project/detail/GET_PURCHASE_ORDER_CREATOR_ERROR'

export const ORDER_TOOL_BY_ORDER_ID_REQUEST =
  'sherrinford/project/detail/ORDER_TOOL_BY_ORDER_ID_REQUEST'
export const ORDER_TOOL_BY_ORDER_ID_SUCCESS =
  'sherrinford/project/detail/ORDER_TOOL_BY_ORDER_ID_SUCCESS'
export const ORDER_TOOL_BY_ORDER_ID_ERROR =
  'sherrinford/project/detail/ORDER_TOOL_BY_ORDER_ID_ERROR'

export const GET_ORDER_TOP_REQUEST = 'sherrinford/project/detail/GET_ORDER_TOP_REQUEST'
export const GET_ORDER_TOP_SUCCESS = 'sherrinford/project/detail/GET_ORDER_TOP_SUCCESS'
export const GET_ORDER_TOP_ERROR = 'sherrinford/project/detail/GET_ORDER_TOP_ERROR'

export const GET_ORDER_PROFILE_REQUEST =
  'sherrinford/project/detail/GET_ORDER_PROFILE_REQUEST'
export const GET_ORDER_PROFILE_SUCCESS =
  'sherrinford/project/detail/GET_ORDER_PROFILE_SUCCESS'
export const GET_ORDER_PROFILE_ERROR =
  'sherrinford/project/detail/GET_ORDER_PROFILE_ERROR'

export const GET_ORDER_REFERENCE_REQUEST =
  'sherrinford/project/detail/GET_ORDER_REFERENCE_REQUEST'
export const GET_ORDER_REFERENCE_SUCCESS =
  'sherrinford/project/detail/GET_ORDER_REFERENCE_SUCCESS'
export const GET_ORDER_REFERENCE_ERROR =
  'sherrinford/project/detail/GET_ORDER_REFERENCE_ERROR'

export const GET_COUNTRY_TAX_REQUEST =
  'sherrinford/project/detail/GET_COUNTRY_TAX_REQUEST'
export const GET_COUNTRY_TAX_SUCCESS =
  'sherrinford/project/detail/GET_COUNTRY_TAX_SUCCESS'
export const GET_COUNTRY_TAX_ERROR = 'sherrinford/project/detail/GET_COUNTRY_TAX_ERROR'

export const POST_INVOICE_REQUEST = 'sherrinford/project/detail/POST_INVOICE_REQUEST'
export const POST_INVOICE_SUCCESS = 'sherrinford/project/detail/POST_INVOICE_SUCCESS'
export const POST_INVOICE_ERROR = 'sherrinford/project/detail/POST_INVOICE_ERROR'

export const PUT_INVOICE_STATUS_REQUEST =
  'sherrinford/project/detail/PUT_INVOICE_STATUS_REQUEST'
export const PUT_INVOICE_STATUS_SUCCESS =
  'sherrinford/project/detail/PUT_INVOICE_STATUS_SUCCESS'
export const PUT_INVOICE_STATUS_ERROR =
  'sherrinford/project/detail/PUT_INVOICE_STATUS_ERROR'

export const PUT_INVOICE_REQUEST = 'sherrinford/project/detail/PUT_INVOICE_REQUEST'
export const PUT_INVOICE_SUCCESS = 'sherrinford/project/detail/PUT_INVOICE_SUCCESS'
export const PUT_INVOICE_ERROR = 'sherrinford/project/detail/PUT_INVOICE_ERROR'

export const POST_PURCHASE_ORDER_CREATOR_REQUEST =
  'sherrinford/project/detail/POST_PURCHASE_ORDER_CREATOR_REQUEST'
export const POST_PURCHASE_ORDER_CREATOR_SUCCESS =
  'sherrinford/project/detail/POST_PURCHASE_ORDER_CREATOR_SUCCESS'
export const POST_PURCHASE_ORDER_CREATOR_ERROR =
  'sherrinford/project/detail/POST_PURCHASE_ORDER_CREATOR_ERROR'

export const PUT_PURCHASE_ORDER_CREATOR_REQUEST =
  'sherrinford/project/detail/PUT_PURCHASE_ORDER_CREATOR_REQUEST'
export const PUT_PURCHASE_ORDER_CREATOR_SUCCESS =
  'sherrinford/project/detail/PUT_PURCHASE_ORDER_CREATOR_SUCCESS'
export const PUT_PURCHASE_ORDER_CREATOR_ERROR =
  'sherrinford/project/detail/PUT_PURCHASE_ORDER_CREATOR_ERROR'

export const GET_ORDER_DETAIL_BY_ORDER_ID_REQUEST =
  'sherrinford/project/detail/GET_ORDER_DETAIL_BY_ORDER_ID_REQUEST'
export const GET_ORDER_DETAIL_BY_ORDER_ID_SUCCESS =
  'sherrinford/project/detail/GET_ORDER_DETAIL_BY_ORDER_ID_SUCCESS'
export const GET_ORDER_DETAIL_BY_ORDER_ID_ERROR =
  'sherrinford/project/detail/GET_ORDER_DETAIL_BY_ORDER_ID_ERROR'

export const GET_INVITED_CREATOR_BY_ORDER_ID_REQUEST =
  'sherrinford/project/detail/GET_INVITED_CREATOR_BY_ORDER_ID_REQUEST'
export const GET_INVITED_CREATOR_BY_ORDER_ID_SUCCESS =
  'sherrinford/project/detail/GET_INVITED_CREATOR_BY_ORDER_ID_SUCCESS'
export const GET_INVITED_CREATOR_BY_ORDER_ID_ERROR =
  'sherrinford/project/detail/GET_INVITED_CREATOR_BY_ORDER_ID_ERROR'

export const GET_PREV_ID_REQUEST = 'sherrinford/project/detail/GET_PREV_ID_REQUEST'
export const GET_PREV_ID_SUCCESS = 'sherrinford/project/detail/GET_PREV_ID_SUCCESS'
export const GET_PREV_ID_ERROR = 'sherrinford/project/detail/GET_PREV_ID_ERROR'

export const GET_NEXT_ID_REQUEST = 'sherrinford/project/detail/GET_NEXT_ID_REQUEST'
export const GET_NEXT_ID_SUCCESS = 'sherrinford/project/detail/GET_NEXT_ID_SUCCESS'
export const GET_NEXT_ID_ERROR = 'sherrinford/project/detail/GET_NEXT_ID_ERROR'

export const GET_PITCH_SUMMARY_REQUEST =
  'sherrinford/project/detail/GET_PITCH_SUMMARY_REQUEST'
export const GET_PITCH_SUMMARY_SUCCESS =
  'sherrinford/project/detail/GET_PITCH_SUMMARY_SUCCESS'
export const GET_PITCH_SUMMARY_ERROR =
  'sherrinford/project/detail/GET_PITCH_SUMMARY_ERROR'

export const GET_INVOICE_WITH_CREATOR_REQUEST =
  'sherrinford/project/detail/GET_INVOICE_WITH_CREATOR_REQUEST'
export const GET_INVOICE_WITH_CREATOR_SUCCESS =
  'sherrinford/project/detail/GET_INVOICE_WITH_CREATOR_SUCCESS'
export const GET_INVOICE_WITH_CREATOR_ERROR =
  'sherrinford/project/detail/GET_INVOICE_WITH_CREATOR_ERROR'

export const GET_REVIEW_BY_ORDER_REQUEST =
  'sherrinford/project/detail/GET_REVIEW_BY_ORDER_REQUEST'
export const GET_REVIEW_BY_ORDER_SUCCESS =
  'sherrinford/project/detail/GET_REVIEW_BY_ORDER_SUCCESS'
export const GET_REVIEW_BY_ORDER_ERROR =
  'sherrinford/project/detail/GET_REVIEW_BY_ORDER_ERROR'

export const IS_LOADING = 'sherrinford/project/detail/IS_LOADING'
export const DATA = 'sherrinford/project/detail/DATA'
export const ACTION = 'sherrinford/project/detail/ACTION'
export const SET_INPUT = 'sherrinford/project/detail/SET_INPUT'

export const SET_TAB_ACTIVE = 'sherrinford/project/detail/SET_TAB_ACTIVE'
export const SET_STATUS_PITCH_SUMMARY =
  'sherrinford/project/detail/SET_STATUS_PITCH_SUMMARY'

export const CLEAR_TAB_ACTIVE = 'sherrinford/project/detail/CLEAR_TAB_ACTIVE'

export const SET_FILTER_BY_RATING = 'sherrinford/project/detail/SET_FILTER_BY_RATING'

export const POST_RECEIPT_REQUEST = 'sherrinford/project/detail/POST_RECEIPT_REQUEST'
export const POST_RECEIPT_SUCCESS = 'sherrinford/project/detail/POST_RECEIPT_SUCCESS'
export const POST_RECEIPT_ERROR = 'sherrinford/project/detail/POST_RECEIPT_ERROR'

export const PUT_RECEIPT_REQUEST = 'sherrinford/project/detail/PUT_RECEIPT_REQUEST'
export const PUT_RECEIPT_SUCCESS = 'sherrinford/project/detail/PUT_RECEIPT_SUCCESS'
export const PUT_RECEIPT_ERROR = 'sherrinford/project/detail/PUT_RECEIPT_ERROR'

export const GET_PAYMENT_LOG_REQUEST =
  'sherrinford/project/detail/GET_PAYMENT_LOG_REQUEST'
export const GET_PAYMENT_LOG_SUCCESS =
  'sherrinford/project/detail/GET_PAYMENT_LOG_SUCCESS'
export const GET_PAYMENT_LOG_ERROR = 'sherrinford/project/detail/GET_PAYMENT_LOG_ERROR'

const initialState = {
  data: {
    id: '',
    profile: {
      id: '',
      name: '',
      profileId: '',
      businessType: '',
      isVatRegistered: false,
      taxNumber: '',
    },
    profileId: '',
    productType: {
      name: '',
      slug: '',
      description: '',
      icon: '',
    },
    service: {
      name: '',
      label: '',
      icon: '',
    },
    user: {
      email: '',
      firstName: '',
      lastName: '',
    },
    status: -1,
    statusLabel: '',
    state: 'Project Created',
    country: {
      name: '',
      currencyCode: '',
    },
    currency: '',
    name: '',
    brand: '',
    objective: '',
    cpvMax: 0,
    cpvMin: 0,
    priceFrom: 0,
    priceTo: 0,
    priceFixed: 0,
    creativeIdea: '',
    startDate: '',
    endDate: '',
    totalContent: 0,
    targetAudience: '',
    termsOfPayment: {
      label: '',
    },
    cpv: 0,
    budget: 0,
    viewers: 0,
    createdAt: '',
    updatedAt: '',
    price_avg: '',
    isOrganic: false,
  },
  orderTool: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  input: {
    toolLink: '',
    timelineLink: '',
  },
  quotation: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  po: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  poCreator: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  top: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [
      {
        installment: 0,
        period: 0,
        upfrontAmount: 100,
        daysPayable: 0,
        installmentAmount: 0,
        projectCost: 0,
      },
    ],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  orderProfiles: [],
  orderDetails: [],
  invitedCreators: [],
  orderReference: [],
  countryTax: {
    vat: 0,
    wht: 0,
    whtTin: 0,
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
  nextId: '',
  prevId: '',
  tabActive: 0,
  pitchSummary: {
    data: {
      count: 0,
      totalPages: 0,
      currentPage: 0,
      qs: {
        skip: 0,
        limit: 0,
        sort: '',
      },
      rows: [],
    },
    filterStatus: '',
    optionStatus: [
      { value: 0, label: 'All' },
      { value: 1, label: 'Not Selected' },
      { value: 2, label: 'Selected' },
      { value: 3, label: 'Withdraw' },
    ],
  },
  invoiceWithCreator: [],
  review: {
    count: 0,
    totalPages: 0,
    currentPage: 0,
    qs: {
      skip: 0,
      limit: 0,
      sort: 'name ASC',
    },
    rows: [],
  },
  filterReview: {
    rating: 0,
  },
  paymentLog: [],
}

export default createReducer(initialState, {
  [GET_PURCHASE_ORDER_CREATOR_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PURCHASE_ORDER_CREATOR_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    poCreator: data,
  }),
  [GET_PURCHASE_ORDER_CREATOR_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [PROJECT_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PROJECT_BY_ID_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [PROJECT_BY_ID_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),
  [SET_INPUT]: (state, data) => ({
    ...state,
    input: {
      ...state.input,
      ...data,
    },
  }),
  [POST_PURCHASE_ORDER_CREATOR_REQUEST]: state => ({
    ...state,
  }),
  [POST_PURCHASE_ORDER_CREATOR_SUCCESS]: state => ({
    ...state,
  }),
  [POST_PURCHASE_ORDER_CREATOR_ERROR]: state => ({
    ...state,
  }),
  [PUT_PURCHASE_ORDER_CREATOR_REQUEST]: state => ({
    ...state,
  }),
  [PUT_PURCHASE_ORDER_CREATOR_SUCCESS]: state => ({
    ...state,
  }),
  [PUT_PURCHASE_ORDER_CREATOR_ERROR]: state => ({
    ...state,
  }),
  [POST_ORDER_TOOL_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_ORDER_TOOL_SUCCESS]: state => ({
    ...state,
  }),
  [POST_ORDER_TOOL_ERROR]: state => ({
    ...state,
  }),
  [ORDER_TOOL_BY_ORDER_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [ORDER_TOOL_BY_ORDER_ID_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    orderTool: data,
  }),
  [ORDER_TOOL_BY_ORDER_ID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [QUOTATION_BY_ORDER_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [QUOTATION_BY_ORDER_ID_SUCCESS]: (state, quotation) => ({
    ...state,
    quotation,
    isLoading: false,
  }),
  [QUOTATION_BY_ORDER_ID_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [PO_BY_ORDER_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PO_BY_ORDER_ID_SUCCESS]: (state, po) => ({
    ...state,
    po,
    isLoading: false,
  }),
  [PO_BY_ORDER_ID_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [GET_ORDER_TOP_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_ORDER_TOP_SUCCESS]: (state, top) => ({
    ...state,
    isLoading: false,
    top,
  }),
  [GET_ORDER_TOP_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_ORDER_PROFILE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_ORDER_PROFILE_SUCCESS]: (state, res) => ({
    ...state,
    isLoading: false,
    orderProfiles: res.rows,
  }),
  [GET_ORDER_PROFILE_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_ORDER_REFERENCE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_ORDER_REFERENCE_SUCCESS]: (state, res) => ({
    ...state,
    isLoading: false,
    orderReference: res.rows,
  }),
  [GET_ORDER_REFERENCE_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_COUNTRY_TAX_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_COUNTRY_TAX_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    countryTax: {
      ...state.countryTax,
      ...data,
    },
  }),
  [GET_COUNTRY_TAX_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [PUT_STATUS_PO_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PUT_STATUS_PO_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [PUT_STATUS_PO_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [PUT_STATUS_ORDER_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PUT_STATUS_ORDER_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [PUT_STATUS_ORDER_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [POST_EMAIL_NOTIFICATION_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_EMAIL_NOTIFICATION_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [POST_EMAIL_NOTIFICATION_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [POST_INVOICE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_INVOICE_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [POST_INVOICE_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [PUT_INVOICE_STATUS_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PUT_INVOICE_STATUS_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [PUT_INVOICE_STATUS_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [PUT_INVOICE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PUT_INVOICE_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [PUT_INVOICE_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_ORDER_DETAIL_BY_ORDER_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [GET_ORDER_DETAIL_BY_ORDER_ID_SUCCESS]: (state, res) => ({
    ...state,
    isLoading: false,
    orderDetails: res.rows,
  }),

  [GET_ORDER_DETAIL_BY_ORDER_ID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_INVITED_CREATOR_BY_ORDER_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [GET_INVITED_CREATOR_BY_ORDER_ID_SUCCESS]: (state, res) => ({
    ...state,
    isLoading: false,
    invitedCreators: res.rows,
  }),

  [GET_INVITED_CREATOR_BY_ORDER_ID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_PREV_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PREV_ID_SUCCESS]: (state, res) => ({
    ...state,
    isLoading: false,
    prevId: res && res[0] && res[0].id ? res[0].id : '',
  }),
  [GET_PREV_ID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_NEXT_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_NEXT_ID_SUCCESS]: (state, res) => ({
    ...state,
    isLoading: false,
    nextId: res && res[0] && res[0].id ? res[0].id : '',
  }),
  [GET_NEXT_ID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_INVOICE_WITH_CREATOR_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [GET_INVOICE_WITH_CREATOR_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    invoiceWithCreator: data,
  }),

  [GET_INVOICE_WITH_CREATOR_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_REVIEW_BY_ORDER_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [GET_REVIEW_BY_ORDER_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    review: data,
  }),

  [GET_REVIEW_BY_ORDER_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [SET_TAB_ACTIVE]: (state, data) => ({
    ...state,
    tabActive: data,
  }),

  [GET_PITCH_SUMMARY_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [GET_PITCH_SUMMARY_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    pitchSummary: {
      ...state.pitchSummary,
      data,
    },
  }),

  [GET_PITCH_SUMMARY_ERROR]: state => ({
    ...state,
    isLoading: true,
  }),

  [SET_STATUS_PITCH_SUMMARY]: (state, data) => ({
    ...state,
    pitchSummary: {
      ...state.pitchSummary,
      filterStatus: data,
    },
  }),

  [CLEAR_TAB_ACTIVE]: state => ({
    ...state,
    tabActive: 0,
  }),
  [SET_FILTER_BY_RATING]: (state, data) => ({
    ...state,
    filterReview: {
      ...state.filterReview,
      rating: data,
    },
  }),

  [GET_PAYMENT_LOG_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PAYMENT_LOG_SUCCESS]: (state, res) => ({
    ...state,
    isLoading: false,
    paymentLog: res.rows,
  }),

  [GET_PAYMENT_LOG_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
})

export const getOrderTop = (searchParam, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [GET_ORDER_TOP_REQUEST, GET_ORDER_TOP_SUCCESS, GET_ORDER_TOP_ERROR],
    shuttle: {
      method: 'GET',
      path: '/order_top',
      qs: {
        search: JSON.stringify(searchParam),
      },
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const getProjectById = (id, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return dispatch => {
    const toDispatch = {
      type: [PROJECT_BY_ID_REQUEST, PROJECT_BY_ID_SUCCESS, PROJECT_BY_ID_ERROR],
      shuttle: {
        method: 'GET',
        path: `/order/${id}`,
        authorization: `${token}`,
      },
      nextAction: res => {
        const searchParam = {
          order: id,
        }
        dispatch(getOrderTop(searchParam))
        cb(res)
      },
    }
    dispatch(toDispatch)
  }
}

export const getQuotationByOrderId = (orderId, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      QUOTATION_BY_ORDER_ID_REQUEST,
      QUOTATION_BY_ORDER_ID_SUCCESS,
      QUOTATION_BY_ORDER_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/quotation?search={"order":"${orderId}"}`,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const getPoByOrderId = (orderId, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [PO_BY_ORDER_ID_REQUEST, PO_BY_ORDER_ID_SUCCESS, PO_BY_ORDER_ID_ERROR],
    shuttle: {
      method: 'GET',
      path: `/purchase_order?search={"order":"${orderId}"}`,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const getOrderToolByOrderId = (orderId, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      ORDER_TOOL_BY_ORDER_ID_REQUEST,
      ORDER_TOOL_BY_ORDER_ID_SUCCESS,
      ORDER_TOOL_BY_ORDER_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/order_tool?search={"order":"${orderId}"}`,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export function getOrderProfile(orderId, searchParam = {}, cb = () => {}) {
  return {
    type: [GET_ORDER_PROFILE_REQUEST, GET_ORDER_PROFILE_SUCCESS, GET_ORDER_PROFILE_ERROR],
    shuttle: {
      method: 'GET',
      path: `/order/${orderId}/profile`,
      qs: {
        search: JSON.stringify(searchParam),
        limit: 9999,
      },
    },
    nextAction: res => cb(res),
  }
}

export function getOrderReference(orderId, cb = () => {}) {
  return {
    type: [
      GET_ORDER_REFERENCE_REQUEST,
      GET_ORDER_REFERENCE_SUCCESS,
      GET_ORDER_REFERENCE_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/order_reference',
      qs: {
        search: JSON.stringify({ order: orderId }),
        limit: 3,
      },
    },
    nextAction: res => cb(res),
  }
}

export function getCountryTax(gcCountry, cb = () => {}) {
  return {
    type: [GET_COUNTRY_TAX_REQUEST, GET_COUNTRY_TAX_SUCCESS, GET_COUNTRY_TAX_ERROR],
    shuttle: {
      method: 'GET',
      path: `/country/${gcCountry}/tax`,
    },
    nextAction: res => cb(res),
  }
}

export const putStatusPurchaseOrder = (id, status, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [PUT_STATUS_PO_REQUEST, PUT_STATUS_PO_SUCCESS, PUT_STATUS_PO_ERROR],
    shuttle: {
      method: 'PUT',
      path: `/purchase_order/${id}/status`,
      payloads: status,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const putStatusOrder = (id, status, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [PUT_STATUS_ORDER_REQUEST, PUT_STATUS_ORDER_SUCCESS, PUT_STATUS_ORDER_ERROR],
    shuttle: {
      method: 'PUT',
      path: `/order/${id}/status`,
      payloads: status,
      authorization: `${token}`,
    },
    nextAction: res => {
      cb(res)
    },
  }
}

export function sendEmailOnCompleteProject(id, cpData, cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      POST_EMAIL_NOTIFICATION_REQUEST,
      POST_EMAIL_NOTIFICATION_SUCCESS,
      POST_EMAIL_NOTIFICATION_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: `/order/${id}/notification`,
      authorization: `${token}`,
      payloads: cpData,
    },
    nextAction: res => {
      cb(res)
    },
  }
}

export function putInvoiceStatus(id, payloads, cb = () => {}) {
  const token = isAuthorized()
  return {
    type: [
      PUT_INVOICE_STATUS_REQUEST,
      PUT_INVOICE_STATUS_SUCCESS,
      PUT_INVOICE_STATUS_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: `/invoice/${id}/status`,
      authorization: token,
      payloads,
    },
    nextAction: res => cb(res),
  }
}

export function putInvoice(id, payloads, cb = () => {}) {
  const token = isAuthorized()
  return {
    type: [PUT_INVOICE_REQUEST, PUT_INVOICE_SUCCESS, PUT_INVOICE_ERROR],
    shuttle: {
      method: 'PUT',
      path: `/invoice/${id}`,
      authorization: token,
      payloads,
    },
    nextAction: res => cb(res),
  }
}

export function postInvoice(payloads, cb = () => {}) {
  const token = isAuthorized()
  return {
    type: [POST_INVOICE_REQUEST, POST_INVOICE_SUCCESS, POST_INVOICE_ERROR],
    shuttle: {
      method: 'POST',
      path: '/invoice',
      authorization: token,
      payloads,
    },
    nextAction: res => cb(res),
  }
}

export const postOrderTool = (data, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [POST_ORDER_TOOL_REQUEST, POST_ORDER_TOOL_SUCCESS, POST_ORDER_TOOL_ERROR],
    shuttle: {
      method: 'POST',
      path: '/order_tool',
      payloads: data,
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}

export const postPurchaseOrderCreator = (data, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      POST_PURCHASE_ORDER_CREATOR_REQUEST,
      POST_PURCHASE_ORDER_CREATOR_SUCCESS,
      POST_PURCHASE_ORDER_CREATOR_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/purchase_order_creator',
      payloads: data,
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}

export const putPurchaseOrderCreator = (id, data, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      PUT_PURCHASE_ORDER_CREATOR_REQUEST,
      PUT_PURCHASE_ORDER_CREATOR_SUCCESS,
      PUT_PURCHASE_ORDER_CREATOR_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: `/purchase_order_creator/${id}`,
      payloads: data,
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}

export const getPurchaseOrderCreator = (orderId, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_PURCHASE_ORDER_CREATOR_REQUEST,
      GET_PURCHASE_ORDER_CREATOR_SUCCESS,
      GET_PURCHASE_ORDER_CREATOR_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/purchase_order_creator',
      qs: {
        search: JSON.stringify({
          order: orderId,
        }),
      },
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}

export function getOrderDetailByOrderId(orderId, cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_ORDER_DETAIL_BY_ORDER_ID_REQUEST,
      GET_ORDER_DETAIL_BY_ORDER_ID_SUCCESS,
      GET_ORDER_DETAIL_BY_ORDER_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/order_detail?search={"order":"${orderId}"}`,
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}

export function getInvitedCreatorByOrderId(orderId) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_INVITED_CREATOR_BY_ORDER_ID_REQUEST,
      GET_INVITED_CREATOR_BY_ORDER_ID_SUCCESS,
      GET_INVITED_CREATOR_BY_ORDER_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/order_detail/${orderId}/status`,
      authorization: token,
      qs: {
        limit: 99999,
      },
    },
  }
}

export function getReviewByOrder(qs) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_REVIEW_BY_ORDER_REQUEST,
      GET_REVIEW_BY_ORDER_SUCCESS,
      GET_REVIEW_BY_ORDER_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/order_review',
      authorization: token,
      qs,
    },
  }
}

export function getPrevId(qs, cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [GET_PREV_ID_REQUEST, GET_PREV_ID_SUCCESS, GET_PREV_ID_ERROR],
    shuttle: {
      method: 'GET',
      path: '/order/prevnextid',
      authorization: token,
      qs,
    },
    nextAction: res => cb(res),
  }
}

export function getNextId(qs, cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [GET_NEXT_ID_REQUEST, GET_NEXT_ID_SUCCESS, GET_NEXT_ID_ERROR],
    shuttle: {
      method: 'GET',
      path: '/order/prevnextid',
      authorization: token,
      qs,
    },
    nextAction: res => cb(res),
  }
}

export function getPitchSummary(qs) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [GET_PITCH_SUMMARY_REQUEST, GET_PITCH_SUMMARY_SUCCESS, GET_PITCH_SUMMARY_ERROR],
    shuttle: {
      method: 'GET',
      path: '/pitch/with_information',
      authorization: token,
      qs,
    },
  }
}

export function getInvoiceWithCreator(qs) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_INVOICE_WITH_CREATOR_REQUEST,
      GET_INVOICE_WITH_CREATOR_SUCCESS,
      GET_INVOICE_WITH_CREATOR_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/invoice/with_creators',
      authorization: token,
      qs,
    },
  }
}

export function postReceipt(payloads, cb = () => {}) {
  return {
    type: [POST_RECEIPT_REQUEST, POST_RECEIPT_SUCCESS, POST_RECEIPT_ERROR],
    shuttle: {
      method: 'POST',
      path: '/ps/receipt',
      payloads,
      universeHost: true,
    },
    nextAction: res => cb(res),
  }
}

export function putReceipt(id, payloads, cb = () => {}) {
  return {
    type: [PUT_RECEIPT_REQUEST, PUT_RECEIPT_SUCCESS, PUT_RECEIPT_ERROR],
    shuttle: {
      method: 'PUT',
      path: `/ps/receipt/${id}`,
      payloads,
      universeHost: true,
    },
    nextAction: res => cb(res),
  }
}

export function getPaymentLog(qs, cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [GET_PAYMENT_LOG_REQUEST, GET_PAYMENT_LOG_SUCCESS, GET_PAYMENT_LOG_ERROR],
    shuttle: {
      method: 'GET',
      path: '/payment_log',
      authorization: token,
      qs,
    },
    nextActions: res => cb(res),
  }
}

export const setInput = data => ({
  type: [SET_INPUT],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setTabActive = data => ({
  type: [SET_TAB_ACTIVE],
  payload: data,
})

export const setStatusPitchSummary = data => ({
  type: [SET_STATUS_PITCH_SUMMARY],
  payload: data,
})

export const clearTabActive = () => ({
  type: [CLEAR_TAB_ACTIVE],
})
export const setFilterByRating = data => ({
  type: [SET_FILTER_BY_RATING],
  payload: data,
})
